import Container from '@/landing/component/container/nogap'

import Head from "@helper/seo/head";

const ProhibitedItem = () => {
  return (
    <Container>
      <Head
        title="SellOn | Prohibited Item"
        type="website"
        url="https://sellon.net"
        siteName="Sellon Tech"
        image="/media/logo/main.png"
      />
      <h1 className='text-center text-3xl font-bold mb-16'>Prohibited Items</h1>
      <div className='grid gap-3 ml-3 mr-3 text-justify'>
        <ol className="list-outside list-decimal grid gap-3 ml-2">
          <li>
            <p className="list outside mb-1"><strong>SellOn prohibits the listing or sale of any item that is set forth in the list of prohibited items. </strong></p>
            <p className="mb-1 indent-8 ml-4">
              If a Seller lists a prohibited item, it
              will be deemed to be a violation of our Terms of Service regardless of
              whether the Seller acted intentionally or not. If SellOn determines
              that a listing is in violation or is otherwise inappropriate SellOn
              may, at its discretion, remove the listing and cancel any related
              transactions up to and including termination or suspension.
            </p>
            <p className="mb-1 ml-4">
              SellOn may not be used in connection with any product, service,
              transaction or activity that in general:
            </p>
            <ul className="list-disc list-outside ml-5">
              <li className='pl-1 -indent-1 ml-6'>
                Violates any law or government regulation, or promotes or
                facilitates such action by third parties;
              </li>
              <li className='pl-1 -indent-1 ml-6'>Is fraudulent, deceptive, unfair or predatory;</li>
              <li className='pl-1 -indent-1 ml-6'>Causes or threatens to damage SellOn’s reputation;</li>
              <li className='pl-1 -indent-1 ml-6'>Violates the terms of any bank, card;</li>
              <li className='pl-1 -indent-1 ml-6'>
                Results in or creates a significant risk of penalties, damages or
                other harm or liability
              </li>
            </ul>
          </li>
          <li>
            <strong> 
              The list of Prohibited Items may be updated from time to time at SellOn’s discretion. 
            </strong>
            <p className="mb-1 ml-4">
              SellOn may not be used to sell any of the following products or
              services:
            </p>
            <ul className="list-disc list-outside ml-5 pl-4">
              <li className='pl-1 -indent-1'>Anything illegal</li>
              <li className='pl-1 -indent-1'>
                <span>Drugs such as:</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>
                    Products, tools, or services specifically offered or intended to
                    be used to create drugs
                  </li>
                  <li className='pl-1 -indent-1'>Grow ingredients for drugs Ex. seeds for cannabis plants</li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>
                <span>Stolen goods:</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-2 -indent-2'>
                    Note: If a purchased item is reported as stolen, a demand for return may be received from the victim or another party, and the item may be confiscated
                  </li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>
                <span className="text-center">
                  Counterfeit goods or goods infringing on a third party's intellectual property rights such as:
                </span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-2 -indent-2'>
                    Listings of non-brand, non-genuine, imitation, fake, or replica
                  </li>
                  <li className='pl-2 -indent-2'>
                    Items in violation of a copyright, including handmade, or other items with copyrighted characters, brand logos, etc.
                  </li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>
                <span> Weapons such as: </span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>Firearms and firearm parts; including airsoft and bb guns</li>
                  <li className='pl-1 -indent-1'>
                    Knives such as switchblades, butterfly knives, knives that are
                    concealed or hidden within other objects, or are made of materials
                    that cannot be detected with a metal detector
                  </li>
                  <li className='pl-1 -indent-1'>Explosives</li>
                  <li className='pl-1 -indent-1'>Self defense weapons</li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>Alcohol</li>
              <li className='pl-1 -indent-1'>
                <span>Tobacco products</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>Cigarettes</li>
                  <li className='pl-1 -indent-1'>
                    E-cigarettes, e-hookahs, or other vaporizing instruments that
                    contain nicotine
                  </li>
                  <li className='pl-1 -indent-1'>Vaporizing liquid without nicotine</li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>
                <span>Items used for identity theft such as:</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>
                    Account credentials, user login information, and/or account access
                    codes
                  </li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>
                <span>Items not in your possession</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>Drop shipping</li>
                  <li className='pl-1 -indent-1'>Advertisements or listings for objects being sought</li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>Items you do not currently have that are on order</li>
              <li className='pl-1 -indent-1'>
                <span>Items that are a safety hazard</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>
                    Note: Flammable or combustible liquids and any other items that
                    require special mailing or handling instructions
                  </li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>
                Products designed to circumvent copyright protection techniques or
                otherwise facilitate the unlicensed use of copyright materials
              </li>
              <li className='pl-1 -indent-1'>
                Age restricted products or products that require a legal approval or
                licenses to be sold
              </li>
              <li className='pl-1 -indent-1'>
                Gambling, including using this service for raffles and mystery
                purchases
              </li>
              <li className='pl-1 -indent-1'>
                <span>Financial products and services such as:</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>Bonds, securities, and insurance</li>
                  <li className='pl-1 -indent-1'>
                    Banknotes or coins of any currency or denomination, or gold
                    bullion
                  </li>
                </ul>
              </li>
              <li className='pl-1 -indent-1'>Live Animals</li>
              <li className='pl-1 -indent-1'>Any item that contains a computer virus, malware, or spyware</li>
              <li className='pl-1 -indent-1'>
                Humans, human body parts, organs, cells, blood, body fluids, and
                items that are soiled with human materials such as used underwear
              </li>
              <li className='pl-1 -indent-1'>
                <span>Explicit items</span>
                <ul className="list-square list-outside ml-1 pl-4">
                  <li className='pl-1 -indent-1'>Sexually explicit items such as sex toys and fetish item</li>
                </ul>
              </li>
            </ul>
          </li>
          <p className="mb-1 ml-4">Note: Any item may be removed at the discretion of the company</p>
        </ol>
      </div>
    </Container>
  );
};

export default ProhibitedItem;
